import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { Controller } from '@commoncore/controller/Controller';
import { LocalStorageProps } from '@commoncore/enums/localStorageProps';
import { FileOperationsImplementation } from '@commoncore/implementation/FileOperationsImplementation';
import { DcgroupcodePickerService } from '@commoncore/services/dcgroupcode-picker.service';
import { GlobalService } from '@commoncore/services/global.service';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { SHARE_DC } from '@mainrepo/app/core/constants/ShareDCURLs';
import { PreLoginSharedViewListImplementation } from '@sharecore/implementation/PreloginSharedViewImplementation';

export class PreLoginSharedViewController extends Controller{
    public preloginImplementation:any;
    public static singleInstance:any = null;
    public universalService:any;
    localStorageService:any;
    shareAccessService:any;
    listService:any;
    router:any;
    loggerService:any;
    containerHeightCalc:any;
    fileOperationsImplementation: any;
  dcGroupCodePicker: any;
  sessionStorageService: any;
    
  public constructor(private globalService:GlobalService) {
    super(globalService);
    this.preloginImplementation= PreLoginSharedViewListImplementation.getInstance(globalService)
    this.fileOperationsImplementation = FileOperationsImplementation.getInstance(globalService);
  }
    
  public static getInstance(connectionService):PreLoginSharedViewController{
		if(this.singleInstance == null){
			this.singleInstance = new PreLoginSharedViewController(connectionService);
			return this.singleInstance;
		}else{
			return this.singleInstance;
		}
	}

  public setEnvObjects(globalService){
		this.universalService=globalService.getUniversalServiceRef();
    this.localStorageService = globalService.getLocalStorageSvcRef();
    this.sessionStorageService = globalService.getSessionStorageSvcRef();
    this.shareAccessService = globalService.getShareAccessServiceRef();
    this.listService = globalService.getListServiceRef();
    this.router = globalService.getRouterRef();
    this.loggerService = globalService.getLoggerServiceRef();
    this.containerHeightCalc = globalService.getContainerHeightCalculatorService()
    this.dcGroupCodePicker = DcgroupcodePickerService.getInstance(globalService);
    }
    
    renderListViewForSharedFiles(files){
      try{
        this.preloginImplementation.setHandler(this.globalService);
        this.preloginImplementation.setDataAsPerDeviceAndView(files);
      }catch(exc){
        console.log("exception in prelogin setting data",exc);
      }
        
    }
    
    async checkPublicOrRestrictedLink(shareKey){
      var profileApiResponse;
      this.preloginImplementation.setHandler(this.globalService);
      let limit = ENV_CONFIG["constants"]["PAGE_LIMIT"] * ENV_CONFIG["constants"]["PAGINATION_BUFFER"];
      try{
        await this.dcGroupCodePicker.decideTypeOfShare(shareKey);
      }catch(err){
        this.preloginImplementation.checkErrorStatus(err);
        return;
      }
      // var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nmsCollabShareInfo"] + '/' +shareKey + '?' + "limit=100" + this.listService.listViewSortOrder;
      var url = ENV_CONFIG.commonUrls["nmsCollabShareInfo"] + '/' +shareKey + "?limit=" + limit + this.listService.listViewSortOrder;
      url = this.dcGroupCodePicker.updateEndpointBasedOnDCGroupCode(url);
      var profileUrl = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["securityURL"] + ENV_CONFIG.commonUrls["getUserDetails"]
      var classRef = this;
      try {
          var userData = this.localStorageService.getUserData(true);
          if(userData){
            profileApiResponse = await this.preloginImplementation.fetchUserProfileDetails(profileUrl);
          }else{
            profileApiResponse = {};
            profileApiResponse["status"] = 200
          }
          if(profileApiResponse["status"] == 200){
          var result = await this.preloginImplementation.checkIfPublicOrRestricted(url);
          if(result == "open" && this.universalService.firstTimeHit){
            var obj = this.shareAccessService.singleObjectShared[0]
            if(obj["objectType"] == 'FR'){
              this.universalService.hideLeftMenu = false;
              this.localStorageService.removeLocalProperty(LocalStorageProps.BREADCRUMBS)
              // this.router.navigate(['/viewfiles', obj.objectKey],{queryParams: {s:this.shareAccessService.shareKey}});
              this.openFolder(obj);
            }
            // to not show preview in prelogin commenting following code
            // else{
            //   obj["previewTranscodeUrl"] = obj["imageTranscodeUrl"]
            //   this.universalService.openPreview(obj)
            // }
          }
          return result
          }else if (profileApiResponse["status"] == 500){ //session is expired and user hits the share link
            window.location.href = '/share/?s=' + shareKey
          }
      } catch (error) {
          console.log("API info error ",error);
          return null
      }
  }

  async getFiles(){
    try{
        var userData = this.localStorageService.getUserData(true);
        const currentFolderKey = this.sessionStorageService.getCurrentFolderkey(true);
        const currentFolder = this.localStorageService.getCurrentFolder(true);
        const rootFolderKey = userData["rootFolderKey"];
        this.universalService.openFolderContent = currentFolderKey && currentFolderKey !=rootFolderKey? true: false;
        let limit = ENV_CONFIG["constants"]["PAGE_LIMIT"] * ENV_CONFIG["constants"]["PAGINATION_BUFFER"];
        if(currentFolder != "" && currentFolder != null && currentFolderKey != ""){
          await this.dcGroupCodePicker.decideTypeOfShare(currentFolder["shareKey"]);
          var url = SHARE_DC["DC_URLS"]["nmsURL"] + ENV_CONFIG.commonUrls["nmsCollabShareInfo"]+ "/" +currentFolder["shareKey"] + ENV_CONFIG.commonUrls["openSharedFolder"] + "/" + currentFolderKey + "?page=0&limit=" + limit  + this.listService.listViewSortOrder;
          this.preloginImplementation.setHandler(this.globalService);
          var result = this.preloginImplementation.fetchFolderData(url)
          return result
        }else{
          this.universalService.showLoader = true;
          try {
            var result = await this.checkPublicOrRestrictedLink(this.shareAccessService.shareKey)
          } catch (error) {
            console.log("component Error is ",error)
          }
          // this.cleverTapEventsService.onShareRequestAccess();
              }
    }catch(exc){
      console.log("exeption in get files",exc)
    }
  }
  

  openFolder(folder){
    this.universalService.showLoader = true;
    if(folder == null){
      return
    }else{
    this.sessionStorageService.setCurrentFolderKey(folder.objectKey, true)
    this.localStorageService.setSharedFolder(folder, true)
    }
    this.fileOperationsImplementation.setHandler(this.globalService);
    const result = this.fileOperationsImplementation.openFolder(folder); 
    if(result == false){

    }else{
      setTimeout(() => {
        if(!this.universalService.listView){
          if(this.universalService.virtualGridEnabled) return;
          this.containerHeightCalc.calculateHeight('.scrollableContainer',['.pseudo-header','.pseudo-top-header'],39)
        }
        else
        this.containerHeightCalc.calculateHeight('#ag-grid',['.pseudo-header','.pseudo-top-header'],84)
      }, 1000);
    }
  }

  decideScrollCall(){
    if (!this.universalService.isMobileDevice) {
      this.onScrollDown();
    } 
  }

  onScrollDown() {
    var url = "";
    url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["shareURL"] + this.shareAccessService.nextLink + this.listService.listViewSortOrder;
    try {
      this.preloginImplementation.setHandler(this.globalService);
      this.preloginImplementation.createUrlForNextLinkOnDesktop(url);
    }
    catch (exc) {
      this.loggerService.log("exception in scroll down")
    }
  }

  onMobileScrollDown(docheight,toppos) {
    var url = "";
    url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["shareURL"] + this.shareAccessService.nextLink + this.listService.listViewSortOrder;
    try {
      this.preloginImplementation.createUrlForNextLinkOnMobile(docheight, toppos, url);
    }
    catch (exc) {
      this.loggerService.log("exception in scroll down",exc)
    }

  }
}